<template>
    <div class="view__tabs">
        <ul class="view__tabs--menu">
            <li :class="getCssClass('campaign-template')">
                <router-link :to="{ name: 'campaign-template', params}">
                  {{ L.localize("Campaigns_Breadcrumb_Template") }}
                </router-link>
            </li>
            <li :class="getCssClass('campaign-code')">
                <router-link :to="{ name: 'campaign-code', params}">
                    {{ L.localize("Campaigns_Breadcrumb_Code") }}
                </router-link>
            </li>
            <li :class="getCssClass('campaign')">
                <router-link :to="{ name: 'campaign', params}">
                    {{ L.localize("Settings_Breadcrumb_Index") }}
                </router-link>
            </li>
            <li :class="getCssClass('campaign-preview')">
                <router-link :to="{ name: 'campaign-preview', params}">
                    {{ L.localize("Campaigns_Breadcrumb_Preview") }}
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script>
import L from 'services/Localization'
import _ from 'lodash'

export default {
  name: 'Submenu',
  data() {
    return {
      L: L
    }
  },
  computed: {
    actions() {
      let menu = {
        label: L.localize('Label_Actions'),
        links: []
      }
      menu.links.push({
        label: L.localize('Settings_Group_Delete'),
        bypassRouter: true,
        asFunction: true,
        url: 'delete'
      })
      return menu
    },
    params() {
      let parameters = {}
      if (this.member) {
        parameters.params = { id: this.member.id }
      }
      return parameters
    }
  },
  methods: {
    getCssClass(name) {
      let currentRouteName = this.$route.name
      let exactMatch = name === currentRouteName
      if (_.isArray(name)) {
        exactMatch = _.includes(name, currentRouteName)
      }
      let baseClass = exactMatch ? 'active' : ''
      return `view__tabs--tab ${baseClass}`
    }
  }
}
</script>




// WEBPACK FOOTER //
// Submenu.vue?07b99208